import Page from '../../../components/Page';
import { Container } from '@mui/material';
import PropertyFeatureForm from './PropertyFeatureForm';

const index = () => {
  return (
    <Page title='Property Feature'>
      <Container maxWidth='xl'>
        <PropertyFeatureForm />
      </Container>
    </Page>
  );
};

export default index;
